import dniImg from "../src/images/dni-logo.jpg";
import ianImg from "../src/images/ian.jpg";

export const benefits = {
  en: {
    title: "Benefits Of News Personalization",
    content: [
      {
        title: "Better Reader Experience",
        type: "green",
        items: [
          "Display **ideal content** based on algorithm",
          "Allow readers to select **topics of interest**",
          "Display content based on **time of day**",
          "Display content based on **location**",
          "Show readers **content they missed**",
          "Individually expand **readers’ horizons**",
        ],
      },
      {
        title: "Better Content Performance",
        type: "blue",
        items: [
          "Increase **visitor retention** rates and reads",
          "Increase content **click and view rates**",
          "Improve **content lifecycle**",
          "**Drive traffic** from reading history",
          "Encourage **content shares**",
          "**Reduce** homepage bounce rates",
        ],
      },
      {
        title: "Better Revenue Performance",
        type: "orange",
        items: [
          "**Higher ad revenues** with increased reach",
          "Increase **ad click rates** with relevancy",
          "Increase **willingness to pay** for content",
          "Sell **high-targeted traffic** at higher prices",
          "Sell more content and **paid subscriptions**",
          "**Market directly** to your readers (opt-in)",
        ],
      },
      {
        title: "Better Digital Journalism",
        type: "red",
        items: [
          "**Reinvest revenue gains** into content",
          "Improve reader **engagement and loyalty**",
          "Effectively reach your **target audience**",
          "Utilize data for better **on-site decisions**",
          "Appeal to a **multitude of audiences**",
          "Configure algorithm **to your needs**",
        ],
      },
    ],
  },
  de: {
    title: "Benefits Of News Personalization",
    content: [
      {
        title: "Better Reader Experience",
        type: "green",
        items: [
          "Display **ideal content** based on algorithm",
          "Allow readers to select **topics of interest**",
          "Display content based on **time of day**",
          "Display content based on **location**",
          "Show readers **content they missed**",
          "Individually expand **readers’ horizons**",
        ],
      },
      {
        title: "Better Content Performance",
        type: "blue",
        items: [
          "Increase **visitor retention** rates and reads",
          "Increase content **click and view rates**",
          "Improve **content lifecycle**",
          "**Drive traffic** from reading history",
          "Encourage **content shares**",
          "**Reduce** homepage bounce rates",
        ],
      },
      {
        title: "Better Revenue Performance",
        type: "orange",
        items: [
          "**Higher ad revenues** with increased reach",
          "Increase **ad click rates** with relevancy",
          "Increase **willingness to pay** for content",
          "Sell **high-targeted traffic** at higher prices",
          "Sell more content and **paid subscriptions**",
          "**Market directly** to your readers (opt-in)",
        ],
      },
      {
        title: "Better Digital Journalism",
        type: "red",
        items: [
          "**Reinvest revenue gains** into content",
          "Improve reader **engagement and loyalty**",
          "Effectively reach your **target audience**",
          "Utilize data for better **on-site decisions**",
          "Appeal to a **multitude of audiences**",
          "Configure algorithm **to your needs**",
        ],
      },
    ],
  },
};

export const careers = {
  en: {
    title: "Join Our Distributed Team",
    tabs: [
      {
        title: "Remote-first",
        content: `
        <p>
          
          <a href="" rel="nofollow" target="_blank">
            remote-first
          </a> 
          
          
          
        </p>
        <p>
          
          
          
          
        </p>
      `,
      },
      {
        title: "Values",
        content: `
        <p>
          
          
          
          
          
        </p>
        <p>
          
          
          
          
        </p>
      `,
      },
    ],
  },
  de: {
    title: "Join Our Distributed Team",
    tabs: [
      {
        title: "Remote-first",
        content: `
        <p>
          
          <a href="" rel="nofollow" target="_blank">
            remote-first
          </a> 
          
          
          
        </p>
        <p>
          
          
          
          
        </p>
      `,
      },
      {
        title: "Values",
        content: `
        <p>
          
          
          
          
          
        </p>
        <p>
          
          
          
          
        </p>
      `,
      },
    ],
  },
};

export const examples = {
  en: {
    title: "Examples & Use Cases",
    tabs: [
      {
        title: "Personalization criteria",
        content: `
        <p>
          Your readers generate a lot of data. AKINGO News uses this data to create a seamless, personalized experience for each user right on your existing website. This allows your readers to easily access their prefered content, meaning they’re more likely to engage, share, and subscribe &mdash; and you’re more likely to reach your revenue targets.
        </p>
        <p>
          Readers can explore a customized edition of your news site as our software utilizes their behavioral and universal data to adjust their content accordingly. Readers also have the option of providing their own data using a settings form tucked quietly into your website. They can improve the level of personalization by selecting content they like and excluding content they don’t like.
        </p>
        <strong>
          Behavioral data
        </strong>
        <ul>
          <li>Prefers or ignores content from certain topics, sections, and tags; for example, a
            reader might frequent the politics section but never read any sports-related articles (or vice versa)</li>
          <li>Prefers certain types of content like short text, long text, photos, or videos</li>
          <li>Prefers or ignores content from certain content creators such as editors or columnists</li>
          <li>Interacts with certain content by commenting, sharing, or liking</li>
          <li>Interacts with certain website features; for example, most viewed or most shared content</li>
          <li>Missed certain content due to not visiting website for a certain period of time</li>
          <li>Certain behavioral schemes that lead to assumptions; for example, a potential jobseeker or
            someone with assumed high brand affinity</li>
        </ul>
        <strong>
          Universal data
        </strong>
        <ul>
          <li>Geolocation: network-provided</li>
          <li>Time of day: for example, breakfast, lunch break, relaxing after work, or commute times</li>
          <li>Day of week: for example, a working day or weekend</li>
          <li>Weather: for example, temperature or inclement conditions</li>
          <li>Time of the year: for example, season, upcoming holidays, and special events</li>
        </ul>

        <strong>
          User-provided data
        </strong>
        <ul>
          <li>Selects or excludes topics, sections, or tags using the integrated settings form</li>
          <li>Reacts to content using a thumbs up feature or emotive icons</li>
          <li>Social graph when the news site uses social networking features</li>
        </ul>
      `,
      },
      {
        title: "Change content",
        content: `
        <p>
          Our goal is to create a completely new digital news experience. AKINGO News can rearrange
          content by taking into account what’s relevant, interesting, and important
          to your reader. You can choose from several different options to achieve the
          ideal arrangement of content for each reader, for example:
        </p>
        <ul>
          <li>Retain selection of content but reorder it according to reader preference.</li>
          <li>Replace content the reader dislikes with content they love.</li>
          <li>Partially or completely replace the top stories of the day depending on reader preference.</li>
          <li>Replace content the reader dislikes with more favorable content that was missed due to not visiting the site for a period of time.</li>
          <li>Use geolocation to show stories relevant to reader’s specific location or environment.</li>
          <li>Display content that corresponds with reader’s time of day; for example, show lighter topics in the morning and important global events during lunch (or vice versa).</li>
          <li>Replace disliked content with relevant stories that may not make it to the homepage otherwise.</li>
          <li>Show content by preferred content creators while hiding content by creators they dislike.</li>
          <li>Display content that corresponds to the day of the week; for example, business-related articles on workdays and leisure-related content on the weekend.</li>
          <li>Hide certain content from the homepage if the user has previously ignored the content.</li>
        </ul>
      `,
      },
      {
        title: "Change layout",
        content: `
        <p>
         Our goal is to create a completely new digital news experience. AKINGO News can change
          the content’s presentation by taking into account what’s relevant, interesting,
          and important to your reader. You can choose from several different options to
          let relevant content take up more space and have less important content fade into
          the background, for example:
        </p>
        <ul>
          <li>Ordering the sections of the homepage according to reader preference; for example, liked content is moved towards the immediately visible area of the website while disliked content is moved down and minimized.</li>
          <li>Emphasizing and accentuating the newspaper’s online store/paid subscription offers in the immediately visible area of the website if a reader shows a high brand affinity for the publisher (assuming their conversion rate for paid products is above average).</li>
          <li>Utilizing location (if reader location is known) to show more local news, move them towards the immediately visible area, and reduce news from less relevant locations.</li>
          <li>Moving specific photo or video content to the immediately visible area and increasing the size and number of this content depending on user preference; for example, highlighting news clips or beautiful, large-scale photos of the day, show more of it.</li>
          <li>Increasing the size and relevance of certain content, such as relevant job offers if the reader is likely looking for a new job, and move it towards the immediately visible area.</li>
          <li>Relocating lists of popular articles (read, commented, shared) towards the immediately visible area if reader enjoys interacting with them.</li>
          <li>Labelling unread content so that readers are able to keep track of content.</li>
        </ul>
      `,
      },
    ],
  },
  de: {
    title: "Examples & Use Cases",
    tabs: [
      {
        title: "Personalization criteria",
        content: `
        <p>
          Your readers generate a lot of data. AKINGO News uses this data to create a seamless, personalized experience for each user right on your existing website. This allows your readers to easily access their prefered content, meaning they’re more likely to engage, share, and subscribe &mdash; and you’re more likely to reach your revenue targets.
        </p>
        <p>
          Readers can explore a customized edition of your news site as our software utilizes their behavioral and universal data to adjust their content accordingly. Readers also have the option of providing their own data using a settings form tucked quietly into your website. They can improve the level of personalization by selecting content they like and excluding content they don’t like.
        </p>
        <strong>
          Behavioral data
        </strong>
        <ul>
          <li>Prefers or ignores content from certain topics, sections, and tags; for example, a
            reader might frequent the politics section but never read any sports-related articles (or vice versa)</li>
          <li>Prefers certain types of content like short text, long text, photos, or videos</li>
          <li>Prefers or ignores content from certain content creators such as editors or columnists</li>
          <li>Interacts with certain content by commenting, sharing, or liking</li>
          <li>Interacts with certain website features; for example, most viewed or most shared content</li>
          <li>Missed certain content due to not visiting website for a certain period of time</li>
          <li>Certain behavioral schemes that lead to assumptions; for example, a potential jobseeker or
            someone with assumed high brand affinity</li>
        </ul>
        <strong>
          Universal data
        </strong>
        <ul>
          <li>Geolocation: network-provided</li>
          <li>Time of day: for example, breakfast, lunch break, relaxing after work, or commute times</li>
          <li>Day of week: for example, a working day or weekend</li>
          <li>Weather: for example, temperature or inclement conditions</li>
          <li>Time of the year: for example, season, upcoming holidays, and special events</li>
        </ul>

        <strong>
          User-provided data
        </strong>
        <ul>
          <li>Selects or excludes topics, sections, or tags using the integrated settings form</li>
          <li>Reacts to content using a thumbs up feature or emotive icons</li>
          <li>Social graph when the news site uses social networking features</li>
        </ul>
      `,
      },
      {
        title: "Change content",
        content: `
        <p>
          Our goal is to create a completely new digital news experience. AKINGO News can rearrange
          content by taking into account what’s relevant, interesting, and important
          to your reader. You can choose from several different options to achieve the
          ideal arrangement of content for each reader, for example:
        </p>
        <ul>
          <li>Retain selection of content but reorder it according to reader preference.</li>
          <li>Replace content the reader dislikes with content they love.</li>
          <li>Partially or completely replace the top stories of the day depending on reader preference.</li>
          <li>Replace content the reader dislikes with more favorable content that was missed due to not visiting the site for a period of time.</li>
          <li>Use geolocation to show stories relevant to reader’s specific location or environment.</li>
          <li>Display content that corresponds with reader’s time of day; for example, show lighter topics in the morning and important global events during lunch (or vice versa).</li>
          <li>Replace disliked content with relevant stories that may not make it to the homepage otherwise.</li>
          <li>Show content by preferred content creators while hiding content by creators they dislike.</li>
          <li>Display content that corresponds to the day of the week; for example, business-related articles on workdays and leisure-related content on the weekend.</li>
          <li>Hide certain content from the homepage if the user has previously ignored the content.</li>
        </ul>
      `,
      },
      {
        title: "Change layout",
        content: `
        <p>
         Our goal is to create a completely new digital news experience. AKINGO News can change
          the content’s presentation by taking into account what’s relevant, interesting,
          and important to your reader. You can choose from several different options to
          let relevant content take up more space and have less important content fade into
          the background, for example:
        </p>
        <ul>
          <li>Ordering the sections of the homepage according to reader preference; for example, liked content is moved towards the immediately visible area of the website while disliked content is moved down and minimized.</li>
          <li>Emphasizing and accentuating the newspaper’s online store/paid subscription offers in the immediately visible area of the website if a reader shows a high brand affinity for the publisher (assuming their conversion rate for paid products is above average).</li>
          <li>Utilizing location (if reader location is known) to show more local news, move them towards the immediately visible area, and reduce news from less relevant locations.</li>
          <li>Moving specific photo or video content to the immediately visible area and increasing the size and number of this content depending on user preference; for example, highlighting news clips or beautiful, large-scale photos of the day, show more of it.</li>
          <li>Increasing the size and relevance of certain content, such as relevant job offers if the reader is likely looking for a new job, and move it towards the immediately visible area.</li>
          <li>Relocating lists of popular articles (read, commented, shared) towards the immediately visible area if reader enjoys interacting with them.</li>
          <li>Labelling unread content so that readers are able to keep track of content.</li>
        </ul>
      `,
      },
    ],
  },
};

export const header = {
  en: {
    title: "News",
    subtitle: "Your Content Can Do Better",
  },
  de: {
    title: "News",
    subtitle: "Your Content Can Do Better",
  },
};

export const meta = {
  en: {
    title: "AKINGO - News Website Personalization",
    canonical: "https://capely.com/",
  },
  de: {
    title: "AKINGO - Personalisierung von News-Websites",
    canonical: "https://capely.com/de/akingo/",
  },
};

export const news = {
  en: {
    title: "Follow Our News Blog",
    content: `
    <p>
      
    </p>
    <ul>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  `,
  },
  de: {
    title: "Follow Our News Blog",
    content: `
    <p>
      
    </p>
    <ul>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  `,
  },
};

export const ourStory = {
  en: {
    title: "Our Story & Our Vision",
    content: [
      `
      <a class="OurStory__photo"
        href="https://www.linkedin.com/in/ianflorian"
        target="_blank"
        rel="nofollow"
      >
        <img src="${ianImg}" alt="Ian Florian Scheel" />
      </a>
      <p>
        In 2013, <a href="https://www.linkedin.com/in/ianflorian" target="_blank" rel="nofollow"> Ian Florian Scheel</a> founded AKINGO, today Capely,
        as a consulting firm for digital/web analytics, a/b/n testing, conversion rate optimization,
        website personalization, and data analysis. Since then, the company has conducted projects in a myriad of
        industries: travel, advertising, energy, transportation, retail, insurance, and gambling.
        Before he started the company, Ian studied economics and business administration. During this time, he built
        two commercial online magazines about mobile phones and pets. He later joined one of Germany’s largest publishing
        houses as a web analytics manager.
        Still, his passion for journalism remained, and in 2016, he quit the consulting business to develop a software
        solution geared to help publishers become more successful online. He formed a team of technology enthusiasts
        to bring AKINGO News to life.
      </p>
      <p>
        <strong>Our vision is to put control back into the hands of publishers.</strong>
      </p>
    `,
      `
      <a class="OurStory__floatBottomBlock"
        href="https://newsinitiative.withgoogle.com"
        target="_blank"
        rel="nofollow"
      ><img src="${dniImg}" alt="Digital News Initiative Logo" /></a>
      Although content is still king, many digital
      news outlets are struggling to finance journalism with online revenues. Today, the most successful content
      platform doubles as the world’s largest social network. Facebook is so successful because it provides a
      highly personalized and optimized news feed that keeps users engaged.
      Similarly, AKINGO News tailors news to the reader to create the most enjoyable reading experience
      possible.
      We use our technology to take a unique approach to delivering digital news, allowing each visitor
      to consume the content they want to read and share.
      With our pluggable, CMS-independent solution, we provide digital news outlets with the tools needed to increase
      their profitability. We are very proud and extremely thankful that our vision is supported by
      <a href="https://newsinitiative.withgoogle.com/dnifund/dni-projects/akingo/" target="_blank" rel="nofollow">Google’s Digital News Initiative</a>, a fund for innovative projects that contribute to the entire news ecosystem.
    `,
    ],
  },
  de: {
    title: "Our Story & Our Vision",
    content: [
      `
      <a class="OurStory__photo"
        href="https://www.linkedin.com/in/ianflorian"
        target="_blank"
        rel="nofollow"
      >
        <img src="${ianImg}" alt="Ian Florian Scheel" />
      </a>
      <p>
        In 2013, <a href="https://www.linkedin.com/in/ianflorian" target="_blank" rel="nofollow"> Ian Florian Scheel</a> founded AKINGO, today Capely,
        as a consulting firm for digital/web analytics, a/b/n testing, conversion rate optimization,
        website personalization, and data analysis. Since then, the company has conducted projects in a myriad of
        industries: travel, advertising, energy, transportation, retail, insurance, and gambling.
        Before he started the company, Ian studied economics and business administration. During this time, he built
        two commercial online magazines about mobile phones and pets. He later joined one of Germany’s largest publishing
        houses as a web analytics manager.
        Still, his passion for journalism remained, and in 2016, he quit the consulting business to develop a software
        solution geared to help publishers become more successful online. He formed a team of technology enthusiasts
        to bring AKINGO News to life.
      </p>
      <p>
        <strong>Our vision is to put control back into the hands of publishers.</strong>
      </p>
    `,
      `
      <a class="OurStory__floatBottomBlock"
        href="https://newsinitiative.withgoogle.com"
        target="_blank"
        rel="nofollow"
      ><img src="${dniImg}" alt="Digital News Initiative Logo" /></a>
      Although content is still king, many digital
      news outlets are struggling to finance journalism with online revenues. Today, the most successful content
      platform doubles as the world’s largest social network. Facebook is so successful because it provides a
      highly personalized and optimized news feed that keeps users engaged.
      Similarly, AKINGO News tailors news to the reader to create the most enjoyable reading experience
      possible.
      We use our technology to take a unique approach to delivering digital news, allowing each visitor
      to consume the content they want to read and share.
      With our pluggable, CMS-independent solution, we provide digital news outlets with the tools needed to increase
      their profitability. We are very proud and extremely thankful that our vision is supported by
      <a href="https://newsinitiative.withgoogle.com/dnifund/dni-projects/akingo/" target="_blank" rel="nofollow">Google’s Digital News Initiative</a>, a fund for innovative projects that contribute to the entire news ecosystem.
    `,
    ],
  },
};

export const slider = {
  en: {
    title: "News",
  },
  de: {
    title: "News",
  },
};

export const solution = {
  en: {
    title: "<span>Make Your News Site</span> More Profitable",
    subtitle:
      "<span>create personalized experiences,</span> seamless for readers",
    leftHint: "Your Readers",
    rightHint: "Your Content",
  },
  de: {
    title:
      "Steigern Sie die <span>Profitabilit&auml;t</span> Ihrer News-Website",
    subtitle:
      "<span>Personalisierte Inhalte,</span> ohne Nachteile f&uuml;r die Leser",
    leftHint: "Your Readers",
    rightHint: "Your Content",
  },
};

export const technology = {
  en: {
    title: "Our Personalization Technology",
    schemeTab: {
      title: "In the cloud",
      description: {
        title: "What to know about AKINGO News",
        content: `
        <ul>
          <li>
            Hosted securely on Google Cloud Platform.
          </li>
          <li>
            Integrates with Cloudflare, a mature global CDN.
          </li>
          <li>
            Completely invisible to your readers.
          </li>
          <li>
            Fail-safe setup with backup solution.
          </li>
        </ul>
      `,
      },
      warningMessage: `
      <strong>Warning:</strong>
      To see our technology visualization, please visit our website using a larger screen
    `,
      schemeBoxes: {
        green: { title: "Your Readers" },
        orange: {
          title: "CDN, e.g. Cloudflare",
          content: `<ul>
          <li>Global network</li>
          <li>Caching</li>
          <li>Request routing</li>
        </ul>`,
        },
        blue: {
          title: "AKINGO News",
          content: `<ul>
          <li>Personalization</li>
          <li>Data collection</li>
          <li>User interface</li>
        </ul>`,
        },
        red: { title: "Your CMS" },
      },
      hints: [
        {
          content: `
          <div>Requests To</div>
          <div>Your Domain</div>
        `,
        },
        {
          content: `
          <div>Requests For</div>
          <div><i>Personalized Content</i></div>
        `,
        },
        {
          content: `
          <div>Requests For</div>
          <div><i>Standard Content</i></div>
          <div>+ Failover</div>
        `,
        },
        {
          content: `
          <div>Requests For</div>
          <div>Content Retrieval</div>
          <div>(Crawler / API)</div>
        `,
        },
      ],
    },
    tabs: [
      {
        title: "On-premises",
        content: `
        While we prefer the cloud, our solution is deployable to your servers as well,
        either on-premises or co-located. Our application consists of dozens of
        microservices and should integrate into your infrastructure easily. If interested
        in on-premise solutions, please get in touch with us to discuss requirements.
        Our current technology stack consists of:

        <ul>
          <li>
            Golang on Unix
          </li>
          <li>
            Node.js on Unix
          </li>
          <li>
            Varnish on Unix
          </li>
        </ul>
      `,
      },
    ],
  },
  de: {
    title: "Our Personalization Technology",
    schemeTab: {
      title: "In the cloud",
      description: {
        title: "What to know about AKINGO News",
        content: `
        <ul>
          <li>
            Hosted securely on Google Cloud Platform.
          </li>
          <li>
            Integrates with Cloudflare, a mature global CDN.
          </li>
          <li>
            Completely invisible to your readers.
          </li>
          <li>
            Fail-safe setup with backup solution.
          </li>
        </ul>
      `,
      },
      warningMessage: `
      <strong>Warning:</strong>
      To see our technology visualization, please visit our website using a larger screen
    `,
      schemeBoxes: {
        green: { title: "Your Readers" },
        orange: {
          title: "CDN, e.g. Cloudflare",
          content: `<ul>
          <li>Global network</li>
          <li>Caching</li>
          <li>Request routing</li>
        </ul>`,
        },
        blue: {
          title: "AKINGO News",
          content: `<ul>
          <li>Personalization</li>
          <li>Data collection</li>
          <li>User interface</li>
        </ul>`,
        },
        red: { title: "Your CMS" },
      },
      hints: [
        {
          content: `
          <div>Requests To</div>
          <div>Your Domain</div>
        `,
        },
        {
          content: `
          <div>Requests For</div>
          <div><i>Personalized Content</i></div>
        `,
        },
        {
          content: `
          <div>Requests For</div>
          <div><i>Standard Content</i></div>
          <div>+ Failover</div>
        `,
        },
        {
          content: `
          <div>Requests For</div>
          <div>Content Retrieval</div>
          <div>(Crawler / API)</div>
        `,
        },
      ],
    },
    tabs: [
      {
        title: "On-premises",
        content: `
        While we prefer the cloud, our solution is deployable to your servers as well,
        either on-premises or co-located. Our application consists of dozens of
        microservices and should integrate into your infrastructure easily. If interested
        in on-premise solutions, please get in touch with us to discuss requirements.
        Our current technology stack consists of:

        <ul>
          <li>
            Golang on Unix
          </li>
          <li>
            Node.js on Unix
          </li>
          <li>
            Varnish on Unix
          </li>
        </ul>
      `,
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./_content.js